
import Vue from "vue";
import { v4 } from "uuid";
import AppMobileFullScreenContainer from "@/components/common/MobileFullScreenContainer.vue";
import { IBreadCrumb } from "winfakt-vue-components";
import {CashierConfig} from "@/models/dossier-configs/cashier";
import {DossierConfigService, UserConfigService} from "@/services";
import {CashierSettings} from "@/models/user-configs/cashier-settings";
import AppSaleTypeSelect from "@/components/sales/SaleTypeSelect.vue";

export default Vue.extend({
	data(){
		return {
			name: "",
			connectedDisplay: "",
			config: new CashierConfig(),
			cashierSettings: new CashierSettings(),
			path: [{
				to: "/settings/plugins", value: this.$ct("components.settings-plugin.plugins")
			}, {value: this.$ct("components.settings-plugin.cashier")}] as IBreadCrumb[],
		};
	},
	computed: {
		displays(): any[]{
			if(!this.config){
				return [{
					text: "",
					value: ""
				}];
			}
			let c = [{
				text: this.$ct("empty-display").toString(),
				value: ""
			}];
			let d = this.config.Displays.map(s => {
				return {
					text: s.name,
					value: s.uuid
				};
			});
			return [...c,...d];
		},
	},
	methods: {
		async saveSettings(){
			await UserConfigService.setCashierSettings(this.cashierSettings);
			this.$wf.notify(this.$ct("save-success").toString(), "success", 3000, "check");
		},
		async save(){
			this.config?.Displays.push({name: this.name,uuid: v4()});
			if(this.config){
				await DossierConfigService.setCashierConfig(this.config);
			}
			this.name = "";
			this.$wf.notify(this.$ct("save-success").toString(), "success", 3000, "check");
		},
		async connect(){
			if(this.cashierSettings){
				this.cashierSettings.ConnectedDisplay = this.connectedDisplay;
				await UserConfigService.setCashierSettings(this.cashierSettings);
			}
		}
	},
	async created(){
		this.cashierSettings = await UserConfigService.getCashierSettings();
		this.connectedDisplay = this.cashierSettings.ConnectedDisplay;
		this.config = await DossierConfigService.getCashierConfig();
	},
	components: {
		AppMobileFullScreenContainer,
		AppSaleTypeSelect
	},
	i18nEx: {
		componentPrefix: "components.settings-plugin.AppCashierDisplay"
	},
});
